const isDev = typeof __DEV__ !== 'undefined' && __DEV__;

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

function format(level: LogLevel, tag: string, message: string): string {
	return `[${level.toUpperCase()}] [${tag}] ${message}`;
}

const LoggingService = {
	debug(tag: string, message: string, ...rest: unknown[]): void {
		if (!isDev) return;
		// eslint-disable-next-line no-console
		console.log(format('debug', tag, message), ...rest);
	},
	info(tag: string, message: string, ...rest: unknown[]): void {
		// eslint-disable-next-line no-console
		console.info(format('info', tag, message), ...rest);
	},
	warn(tag: string, message: string, ...rest: unknown[]): void {
		// eslint-disable-next-line no-console
		console.warn(format('warn', tag, message), ...rest);
	},
	error(tag: string, message: string, ...rest: unknown[]): void {
		// eslint-disable-next-line no-console
		console.error(format('error', tag, message), ...rest);
	},
};

export default LoggingService;
